"use strict";

var _interopRequireWildcard = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.json.stringify.js");

require("regenerator-runtime/runtime.js");

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _Title = _interopRequireDefault(require("./components/Title"));

var _SettingItem = _interopRequireDefault(require("./components/SettingItem"));

var _StatusTag = _interopRequireDefault(require("./components/StatusTag"));

var _DChangePwd = _interopRequireDefault(require("./components/DChangePwd"));

var _DBind = _interopRequireDefault(require("./components/DBind"));

var _DGoogle = _interopRequireDefault(require("./components/DGoogle"));

var _Button = _interopRequireDefault(require("./components/Button"));

var _GoogleBind = _interopRequireDefault(require("./components/google/GoogleBind"));

var _GoogleDialog = _interopRequireDefault(require("./components/google/GoogleDialog"));

var _message = require("@/components/dialog/message");

var Account = _interopRequireWildcard(require("@/model/user/account"));

var _ucenter = require("@/model/ucenter/ucenter");

var _commonMixin = _interopRequireDefault(require("@/components/common/commonMixin.vue"));

var _jsMd = _interopRequireDefault(require("js-md5"));

var _security = require("@/model/ucenter/security");

var _globalFun = _interopRequireDefault(require("@/assets/js/globalFun.js"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  mixins: [_commonMixin.default],
  data: function data() {
    return {
      pwdDialogVisible: false,
      bindDialogVisible: false,
      verificationVisible: false,
      bindType: "mobile",
      // 绑定/修改 类型
      googleVerifyStatus: true,
      accountEmailFlag: true,
      accountMobileFlag: true,
      mobileBind: false,
      // 手机绑定状态
      emailBind: false,
      // 邮箱绑定状态
      mobileStatus: false,
      // 手机验证状态 false:
      emailStatus: false,
      // 邮箱验证状态
      openGoogle: false,
      // 谷歌验证状态
      googleStatus: 1,
      // 谷歌验证状态
      all_areacode: {},
      // 所有区号
      openSetGoogle: false,
      // 打开设置谷歌
      googleValidator: [{
        img: "./../../assets/img/AppleStore.png",
        link: ""
      }, {
        img: "./../../assets/img/AppleStore.png",
        link: ""
      }, {
        img: "./../../assets/img/AppleStore.png",
        link: ""
      }],
      accountInfo: {},
      authInfo: {},
      isBindEmail: false,
      // 是否在绑定邮箱
      changeDBindMobile: false,
      // 是否修改
      confirmLoading: false,
      is_bind_security: 0,
      voucherInterval: null,
      globalFun: _globalFun.default
    };
  },
  created: function created() {
    var _this = this;

    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // await this.getGooglStatus();
              _this.getUserInfo();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  destroyed: function destroyed() {
    clearInterval(this.voucherInterval);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.voucherInterval);
  },
  methods: {
    onDialogOpen: function onDialogOpen() {
      this.getUserInfo();
    },
    onChangePassWord: function onChangePassWord() {
      if (this.is_bind_security == 1) {
        (0, _message.showMessage)({
          message: this.translateTitle("\u8BF7\u5148\u7ED1\u5B9A\u8C37\u6B4C\u3001\u624B\u673A\u6216\u8005\u90AE\u7BB1"),
          type: "warning"
        });
      } else {
        this.pwdDialogVisible = true;
      }
    },
    getUserInfo: function getUserInfo() {
      var _this2 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _ref, authInfo, accountInfo;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // let { authInfo, accountInfo } = await Account.getUserInfo();
                _ref = sessionStorage.userInfo ? JSON.parse(sessionStorage.userInfo) : {}, authInfo = _ref.authInfo, accountInfo = _ref.accountInfo;
                _this2.accountInfo = accountInfo;
                _this2.authInfo = authInfo;

                if (authInfo) {
                  _this2.is_bind_security = authInfo.is_bind_security;
                  _this2.mobileStatus = authInfo.open_mobile === 0 ? false : true;
                  _this2.emailStatus = authInfo.open_email === 0 ? false : true;
                  _this2.openGoogle = authInfo.open_google === 0 ? false : true;
                  _this2.googleStatus = authInfo.open_google;

                  if (_this2.openGoogle == true && _this2.mobileStatus == false && _this2.emailStatus == false) {
                    _this2.googleVerifyStatus = false;
                  } else {
                    _this2.googleVerifyStatus = true;
                  }
                }

                if (accountInfo) {
                  _this2.mobileBind = accountInfo.mobile ? true : false;
                  _this2.emailBind = accountInfo.email ? true : false;
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getGooglStatus: function getGooglStatus() {
      var _this3 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _yield$bingGoogleVeri, status, data, msg;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0, _security.bingGoogleVerifyStatus)();

              case 2:
                _yield$bingGoogleVeri = _context3.sent;
                status = _yield$bingGoogleVeri.status;
                data = _yield$bingGoogleVeri.data;
                msg = _yield$bingGoogleVeri.msg;

                if (!(status !== 200)) {
                  _context3.next = 8;
                  break;
                }

                return _context3.abrupt("return");

              case 8:
                _this3.googleStatus = data.bing_google_status;

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 绑定/修改手机
    onBindMobileClick: function onBindMobileClick() {
      var _this4 = this;

      var mobileBind = this.mobileBind;
      this.bindType = "mobile";
      var username = this.accountInfo.username;
      var open_email = this.authInfo.open_email;

      if (username && open_email === 0) {
        this.accountEmailFlag = false;
        this.accountMobileFlag = true;
      }

      this.$nextTick(function () {
        return _this4.bindDialogVisible = true;
      });

      if (mobileBind) {
        this.changeDBindMobile = true;
      }
    },
    // 绑定邮箱
    onBindEmailClick: function onBindEmailClick() {
      var _this5 = this;

      this.bindType = "email";
      var username = this.accountInfo.username;
      var open_mobile = this.authInfo.open_mobile;

      if (username && open_mobile === 0) {
        this.accountMobileFlag = false;
        this.accountEmailFlag = true;
      }

      this.$nextTick(function () {
        return _this5.bindDialogVisible = true;
      });
      this.isBindEmail = true;
    },
    // 打开设置绑定谷歌
    onBindGoogleClick: function onBindGoogleClick() {
      this.openSetGoogle = true;
    },
    // 关闭谷歌认证
    closeGoogle: function closeGoogle() {
      this.verificationVisible = true;
    },
    //
    subGoogleSuccess: function subGoogleSuccess() {
      var _this6 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this6.getGooglStatus();

                _context4.next = 3;
                return _this6.newGetUserInfo();

              case 3:
                _this6.openSetGoogle = false;

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    onCancel: function onCancel() {
      if (this.$refs.changePwd_ref) {
        this.$refs.changePwd_ref.clearCode();
      }

      if (this.$refs.google_ref) {
        this.$refs.google_ref.clearCode();
      }

      this.pwdDialogVisible = false;
      this.bindDialogVisible = false;
      this.verificationVisible = false;
      this.changeDBindMobile = false;
      this.isBindEmail = false;
    },
    // 确认提交
    onOk: function onOk() {
      var _this7 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var params, changePwd_status, mobile_status, change_mobile_status, email_status, google_status, data, _data, _data2, _data3, _data4;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                params = {};
                changePwd_status = _this7.$refs.changePwd_ref ? _this7.$refs.changePwd_ref.submitForm() : true;
                mobile_status = _this7.$refs.mobile_ref ? _this7.$refs.mobile_ref.submitForm() : true;
                change_mobile_status = _this7.$refs.mobileChange_ref ? _this7.$refs.mobileChange_ref.submitForm() : true;
                email_status = _this7.$refs.email_ref ? _this7.$refs.email_ref.submitForm() : true;
                google_status = _this7.$refs.google_ref ? _this7.$refs.google_ref.submitForm() : true;

                if (changePwd_status && mobile_status && change_mobile_status && email_status && google_status) {
                  _context5.next = 8;
                  break;
                }

                return _context5.abrupt("return");

              case 8:
                /* 密码 */
                if (_this7.$refs.changePwd_ref) {
                  data = _this7.$refs.changePwd_ref.submitForm();
                  params = (0, _objectSpread2.default)({}, data);
                  delete params.confirmNewPwd;
                  params.old_password = (0, _jsMd.default)(params.old_password);
                  params.password = (0, _jsMd.default)(params.password);
                }
                /* 手机 */


                if (_this7.$refs.mobile_ref) {
                  _data = _this7.$refs.mobile_ref.submitForm();
                  params = Object.assign(params, (0, _objectSpread2.default)({}, _data));
                }
                /* 新手机 */


                if (_this7.$refs.mobileChange_ref) {
                  _data2 = _this7.$refs.mobileChange_ref.submitForm();
                  _data2.code = _data2.mobile_code;
                  delete _data2.mobile_code;
                  params = Object.assign(params, (0, _objectSpread2.default)({}, _data2));
                }
                /* 邮箱 */


                if (_this7.$refs.email_ref) {
                  _data3 = _this7.$refs.email_ref.submitForm();
                  params = Object.assign(params, (0, _objectSpread2.default)({}, _data3));
                }
                /* 谷歌 */


                if (_this7.$refs.google_ref) {
                  _data4 = _this7.$refs.google_ref.submitForm();
                  params = Object.assign(params, (0, _objectSpread2.default)({}, _data4));
                }
                /* 提交请求 */
                // 修改密码


                if (!_this7.$refs.changePwd_ref) {
                  _context5.next = 17;
                  break;
                }

                _context5.next = 16;
                return (0, _security.updatePassword)(params).then(function (res) {
                  return _this7.successTip(res, _this7.translateTitle("\u5BC6\u7801\u4FEE\u6539\u6210\u529F"));
                });

              case 16:
                return _context5.abrupt("return");

              case 17:
                if (!(!_this7.mobileStatus && !_this7.isBindEmail)) {
                  _context5.next = 21;
                  break;
                }

                _context5.next = 20;
                return (0, _security.bindMobile)(params).then(function (res) {
                  return _this7.successTip(res, _this7.translateTitle("\u624B\u673A\u7ED1\u5B9A\u6210\u529F"));
                });

              case 20:
                return _context5.abrupt("return");

              case 21:
                if (!_this7.$refs.mobileChange_ref) {
                  _context5.next = 27;
                  break;
                }

                params["old_mobile_code"] = params["mobile_code"];
                params["mobile_code"] = params["code"];
                _context5.next = 26;
                return (0, _security.undataMobile)(params).then(function (res) {
                  return _this7.successTip(res, _this7.translateTitle("\u4FEE\u6539\u624B\u673A\u53F7\u6210\u529F"));
                });

              case 26:
                return _context5.abrupt("return");

              case 27:
                if (!(_this7.$refs.email_ref && _this7.isBindEmail)) {
                  _context5.next = 31;
                  break;
                }

                _context5.next = 30;
                return (0, _security.bindEmail)(params).then(function (res) {
                  return _this7.successTip(res, _this7.translateTitle("\u90AE\u7BB1\u7ED1\u5B9A\u6210\u529F"));
                });

              case 30:
                return _context5.abrupt("return");

              case 31:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // 密码修改状态判断
    checkPwdStatus: function checkPwdStatus(callback) {
      var changePwd_status = this.$refs.changePwd_ref ? this.$refs.changePwd_ref.submitForm() : true;
      var status = changePwd_status ? true : false;
      callback(status);
    },
    // 成功提醒
    successTip: function successTip(res, message) {
      this.confirmLoading = false;

      if (res.status === 200) {
        this.onCancel();
        (0, _message.showMessage)({
          message: message,
          type: "success"
        });
        this.newGetUserInfo();
      } else if (res.status === -6071004) {
        this.$refs.mobile_ref ? this.$refs.mobile_ref.clearCode() : null;
        this.$refs.mobileChange_ref ? this.$refs.mobileChange_ref.clearCode() : null;
        this.$refs.email_ref ? this.$refs.email_ref.clearCode() : null;
      } else {
        (0, _message.showMessage)({
          message: res.msg ? res.msg : res.status
        });
      }
    },
    // 获取新的用户信息
    newGetUserInfo: function newGetUserInfo() {
      var _this8 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return (0, _ucenter.getUserInfo)().then(function (_ref2) {
                  var data = _ref2.data,
                      msg = _ref2.msg,
                      status = _ref2.status;

                  if (status === 200) {
                    if (data != null) {
                      sessionStorage.setItem("userInfo", JSON.stringify(data));
                    }

                    _this8.getUserInfo();
                  } else {
                    (0, _message.showMessage)({
                      message: msg ? msg : status
                    });
                  }
                });

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    }
  },
  computed: {
    googleBtnText: function googleBtnText() {
      var tempVal = "";
      var googleStatus = this.googleStatus;

      switch (googleStatus) {
        case 1:
          tempVal = this.translateTitle("\u5173\u95ED\u8BA4\u8BC1");

        case 2:
          tempVal = this.translateTitle("\u5173\u95ED");
      }

      return tempVal;
    }
  },
  components: {
    TopTitle: _Title.default,
    SettingItem: _SettingItem.default,
    StatusTag: _StatusTag.default,
    ChangePwd: _DChangePwd.default,
    GButton: _Button.default,
    DBind: _DBind.default,
    DGoogle: _DGoogle.default,
    GoogleBind: _GoogleBind.default,
    GoogleDialog: _GoogleDialog.default
  }
};
exports.default = _default;